var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.8936L24 26.8936M24 26.8936L30 32.8936M24 26.8936V40.8936M44 18.8936H4M11 36.8936H10.4C8.15979 36.8936 7.03969 36.8936 6.18404 36.4576C5.43139 36.0741 4.81947 35.4622 4.43597 34.7095C4 33.8539 4 32.7338 4 30.4936V15.2936C4 13.0533 4 11.9332 4.43597 11.0776C4.81947 10.3249 5.43139 9.71302 6.18404 9.32953C7.03969 8.89355 8.15979 8.89355 10.4 8.89355H37.6C39.8402 8.89355 40.9603 8.89355 41.816 9.32953C42.5686 9.71303 43.1805 10.3249 43.564 11.0776C44 11.9332 44 13.0533 44 15.2936V30.4936C44 32.7338 44 33.8539 43.564 34.7095C43.1805 35.4622 42.5686 36.0741 41.816 36.4576C40.9603 36.8936 39.8402 36.8936 37.6 36.8936H37",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardUpload);
export default __webpack_public_path__ + "static/media/credit-card-upload.3620033d753340fad9b2efc6e2f02e1b.svg";
export { ForwardRef as ReactComponent };